/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 10:21:13
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-19 11:39:12
 */
/* eslint-disable */
import config from '@/config/config'
import { mapState, mapMutations, mapActions } from 'vuex'

const login = {
  data () {
    return {
      code: '', // 用户登录凭证（有效期五分钟）
      refreshJwt: 0,
    }
  },
  computed: {
    ...mapState({
      mxUserInfo: state => state.user.currentUserInfo,
      mxCompanyId: state => state.switchInfo.companyId,
      mxSettlementId: state => state.switchInfo.settlementId,
    })
  },
  methods: {
  }
}

export default login
